import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/sections/ecosystem/kz/flag.webp")